import React, {FormEvent} from "react";
import Select from "react-select";

type Props = {
    onTextInputChange: (event:FormEvent<HTMLInputElement>) => void
    onSelectChange: (selectedOptions: any) => void
    workplaces: { value: string, label: string }[]
    keywordsPlaceholder: string
    workplacesPlaceholder: string
}

const JobsFilters: React.FC<Props> = ({onTextInputChange, onSelectChange, workplaces, keywordsPlaceholder, workplacesPlaceholder}) => {
    return (
        <div className='jobs-filters'>
            <div className={'input-wrapper'}>
                <input type={'text'} onChange={onTextInputChange} placeholder={keywordsPlaceholder}/>
            </div>

            <div className={'select-wrapper'}>
                <Select options={workplaces} onChange={onSelectChange} isMulti={true} placeholder={workplacesPlaceholder}/>
            </div>
        </div>
    )
}

export default JobsFilters;
